import React from "react";
import { useSelector } from "react-redux";
import { selectHasParentRegistration } from "../../../redux/slices/appSettingsSlice";
import { selectAllRegistration } from "../../../redux/slices/registrationSlice";
import { selectCurrentForm } from "../../../redux/slices/currentFormSlice";
import { fetchFields } from "../../../redux/slices/fieldsSlice";
import UpdateFields from "./UpdateFields";

const ConnectedUpdateFields = () => {
    const hasParentRegistration = useSelector(selectHasParentRegistration);
    const { currentRegistration } = useSelector(selectAllRegistration);
    const currentForm = useSelector(selectCurrentForm);

    const updateFieldsProps = {
        currentRegistration,
        formId: currentForm,
        hasParentRegistration,
        // Action
        fetchFields,
    };
    return <UpdateFields {...updateFieldsProps} />;
};

export default ConnectedUpdateFields;
